import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { ChatMessageRequest } from "../../xapp/ChatServerMessage";
import { writeMessage } from "./writeMessage";

export default function sendMessage(msg: ChatMessageRequest): ChatServerAsyncActionType {
    return chatServer => (dispatch, getState) => {
        const state = getState();

        // Don't allow visitor to send message if offline
        if (state.accountStatus === "offline" && !state.isChatting) return;

        // Write user message to Redux before server send so it appears above streaming response
        if (msg.msg) {
            dispatch(writeMessage(msg.msg, state.visitor, +new Date()));
        }

        chatServer.sendChatMsgRequest(msg, () => {});
    };
}
